import ProductSummaryListProvider from './hooks/useProductSummaryList';

import { ProductSummaryListProps } from './@types/ProductSummaryListProps';
import SliderLayout from '../../slider-layout/SliderLayout/SliderLayout';

const ProductSummaryList = (props: ProductSummaryListProps) => {
	const sliderLayoutProps = props.children[0].props.comp.props;
	const componentId = props.children[0].props.comp.componentId;

	return (
		<ProductSummaryListProvider {...props}>
			{props.blocks.length ? (
				<SliderLayout {...sliderLayoutProps} componentId={componentId}>
					{props.blocks}
				</SliderLayout>
			) : (
				props.children
			)}
		</ProductSummaryListProvider>
	);
};

export default ProductSummaryList;
